import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

const SeasonalMenuEdit = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    // Redirect to the items page which serves as the edit/review page
    if (id) {
      navigate(`/seasonal-menu/${id}/items`, { replace: true });
    }
  }, [id, navigate]);

  return null;
};

export default SeasonalMenuEdit;